export const fundingMethodArtwork = {
    apple_pay: 'apple-pay',
    google_pay: 'google-pay',
    card: 'card',
    paypal: 'paypal',
    venmo: 'venmo',
    revolut_pay: 'revolut',
    moonpay_balance: 'moonpay',
    sepa: 'sepa',
    gbp_bank_transfer: 'uk',
    gbp_open_banking_payment: 'uk-open',
    pix_instant_payment: 'pix',
};
